import i18n from '../language/index'
//默认路由列表,当页面请求错误或失败时，使用
import Index from '@/view/index.vue'
export default [
  {
    path: '/index',
    name: 'index',
    component: Index,
    alias:'',
    meta:{
      title:i18n.t('router_default_70')
    },
    title:i18n.t('router_default_70')
  },
  {
    path: '/product_index',
    name: 'product_index',
    component: Index,
    alias:'',
    meta:{
      title:i18n.t('router_default_71')
    },
    title:i18n.t('router_default_71')
  },
  {
    path: '/product',
    name: 'product',
    component: Index,
    alias:'',
    meta:{
      title:i18n.t('router_default_72')
    },
    title:i18n.t('router_default_72')
  },
  {
    path: '/article_index',
    name: 'article_index',
    component: Index,
    alias:'',
    meta:{
      title:i18n.t('router_default_73')
    },
    title:i18n.t('router_default_73')
  },
  {
    path: '/article',
    name: 'article',
    component: Index,
    alias:'',
    meta:{
      title:i18n.t('router_default_74')
    },
    title:i18n.t('router_default_74')
  },
  {
    path: '/case_index',
    name: 'case_index',
    component: Index,
    alias:'',
    meta:{
      title:i18n.t('router_default_75')
    },
    title:i18n.t('router_default_75')
  },
  {
    path: '/case',
    name: 'case',
    component: Index,
    alias:'',
    meta:{
      title:i18n.t('router_default_76')
    },
    title:i18n.t('router_default_76')
  },
  {
    path: '/video_index',
    name: 'video_index',
    component: Index,
    alias:'',
    meta:{
      title:i18n.t('router_default_77')
    },
    title:i18n.t('router_default_77')
  },
  {
    path: '/video',
    name: 'video',
    component: Index,
    alias:'',
    meta:{
      title:i18n.t('router_default_78')
    },
    title:i18n.t('router_default_78')
  },
  {
    path: '/help_index',
    name: 'help_index',
    component: Index,
    alias:'',
    meta:{
      title:i18n.t('router_default_79')
    },
    title:i18n.t('router_default_79')
  },
  {
    path: '/help',
    name: 'help',
    component: Index,
    alias:'',
    meta:{
      title:i18n.t('router_default_80')
    },
    title:i18n.t('router_default_80')
  },
  {
    path: '/download_index',
    name: 'download_index',
    component: Index,
    alias:'',
    meta:{
      title:i18n.t('router_default_81')
    },
    title:i18n.t('router_default_81')
  },
  {
    path: '/about',
    name: 'about',
    component: Index,
    alias:'',
    meta:{
      title:i18n.t('router_default_82')
    },
    title:i18n.t('router_default_82')
  },
  {
    path: '/culture',
    name: 'culture',
    component: Index,
    alias:'',
    meta:{
      title:i18n.t('router_default_83')
    },
    title:i18n.t('router_default_83')
  },
  {
    path: '/honor',
    name: 'honor',
    component: Index,
    alias:'',
    meta:{
      title:i18n.t('router_default_84')
    },
    title:i18n.t('router_default_84')
  },
  {
    path: '/contact',
    name: 'contact',
    component: Index,
    alias:'',
    meta:{
      title:i18n.t('router_default_85')
    },
    title:i18n.t('router_default_85')
  },
  {
    path: '/message',
    name: 'message',
    component: Index,
    alias:'',
    meta:{
      title:i18n.t('router_default_86')
    },
    title:i18n.t('router_default_86')
  },
  {
    path: '/job',
    name: 'job',
    component: Index,
    alias:'',
    meta:{
      title:i18n.t('router_default_87')
    },
    title:i18n.t('router_default_87')
  },
  {
    path: '/job_item',
    name: 'job_item',
    component: Index,
    alias:'',
    meta:{
      title:i18n.t('router_default_88')
    },
    title:i18n.t('router_default_88')
  },
  {
    path: '/sitemap',
    name: 'sitemap',
    component: Index,
    alias:'',
    meta:{
      title:i18n.t('router_default_89')
    },
    title:i18n.t('router_default_89')
  },
  {
    path: '/search',
    name: 'search',
    component: Index,
    alias:'',
    meta:{
      title:i18n.t('router_default_90')
    },
    title:i18n.t('router_default_90')
  },
  {
    path: '/user_login',
    name: 'user_login',
    component: Index,
    alias:'',
    meta:{
      title:i18n.t('view_login_index_34')
    },
    title:i18n.t('view_login_index_34')
  },
  {
    path: '/user_register',
    name: 'user_register',
    component: Index,
    alias:'',
    meta:{
      title:i18n.t('router_default_91')
    },
    title:i18n.t('router_default_91')
  },
  {
    path: '/user_index',
    name: 'user_index',
    component: Index,
    alias:'',
    meta:{
      title:i18n.t('router_default_92')
    },
    title:i18n.t('router_default_92')
  },
  {
    path: '/user_forget',
    name: 'user_forget',
    component: Index,
    alias:'',
    meta:{
      title:i18n.t('router_default_93')
    },
    title:i18n.t('router_default_93')
  }
  
]



// WEBPACK FOOTER //
// ./src/router/default.js